<template>
	<component :is="currentFallDetailView" ref="childComponent" />
</template>

<script>
import { computed, defineComponent } from 'vue';
import { useStore, authUser } from '../store';
import FallDetail from '@/views/FallDetail.vue';
import FallDetailPublic from '@/views/FallDetailPublic.vue';
import FallDetailVorstand from './FallDetailVorstand.vue';
import FallDetailWerberat from './FallDetailWerberat.vue';

export default defineComponent({
	name: 'FallDetailWrapper',
	components: {},
	setup() {
		const store = useStore();
		const loggedin = computed(() => store.state.loggedin);
		const user = computed(() => store.state.user);
		const isLoggedIn = loggedin.value && user.value;

		const currentFallDetailView = computed(() => {
			if (!isLoggedIn) {
				return FallDetailPublic;
			}

			const authUserRoles = authUser.value.roles.map((role) => role.name);
			if (authUserRoles.includes('Vorstand')) {
				return FallDetailVorstand;
			} else if (
				authUserRoles.includes('Werberat') ||
				authUserRoles.includes('Junger Werberat') ||
				authUserRoles.includes('Kleiner Senat A') ||
				authUserRoles.includes('Kleiner Senat B')
			) {
				return FallDetailWerberat;
			}
			return FallDetail;
		});

		return {
			currentFallDetailView,
		};
	},
	beforeRouteLeave(to, from, next) {
		const childComponent = this.$refs.childComponent;

		if (childComponent && typeof childComponent.handleBeforeRouteLeave === 'function') {
			childComponent.handleBeforeRouteLeave(to, from, next);
		} else {
			next();
		}
	},
});
</script>
